const PurchaseOrderPopup = ({
  isOpen,
  onClose,
  data = [],
  selected = [],
  onSelect = () => {},
  handleConfirm = () => {}, // ✅ add this
}) => {
  if (!isOpen) return null;

  const handleCheckboxChange = (poName) => {
    if (selected.includes(poName)) {
      onSelect(selected.filter((item) => item !== poName));
    } else {
      onSelect([...selected, poName]);
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Supplier Purchase Orders</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            {data.length === 0 ? (
              <p>No Purchase Orders Found</p>
            ) : (
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Select</th>
                    <th>PO Name</th>
                    <th>Supplier</th>
                    <th>Transaction Date</th>
                    <th>Company</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((po) => (
                    <tr key={po.name}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selected.includes(po.name)}
                          onChange={() => handleCheckboxChange(po.name)}
                        />
                      </td>
                      <td>{po.name}</td>
                      <td>{po.supplier}</td>
                      <td>{po.transaction_date}</td>
                      <td>{po.company}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <div className="modal-footer">
            <button className="mb-0 align-items-center custom-btn-00989" onClick={onClose}>Close</button>
            <button
            style={{background : '#FC8B5C'}}
              className="mb-0 align-items-center custom-btn-00989"
              onClick={() => handleConfirm(selected)} 
              disabled={selected.length === 0}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


export default PurchaseOrderPopup;
